




































import type { AuthenticationStep } from '@getaccept/lib-shared/src/authentication/types/authentication-step';
import { AuthenticationStepType } from '@getaccept/lib-shared/src/authentication/types/enums/authentication-step-type';
import type { PropType } from '@vue/composition-api';
import { onBeforeUnmount, onMounted, computed, ref, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import Pin from '../../common/components/Pin.vue';

export default defineComponent({
  components: {
    Pin,
  },
  props: {
    authStep: {
      type: Object as PropType<AuthenticationStep>,
      required: true,
    },
    isCorrectPin: {
      type: Boolean,
      default: false,
    },
    submittingResponse: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const pin = ref('');
    const hasSentPin = ref(false);
    const pinLength = 6;

    const description = computed(
      (): string => `${t('sms-auth-description')} ${lastFourDigits.value}.`
    );
    const infoText = computed((): string => `${t('sms-info-text')} ${lastFourDigits.value}.`);
    const lastFourDigits = computed((): string => props.authStep.data.mobile);
    const disableValidate = computed((): boolean => pin.value.length !== pinLength);
    const wrongPin = computed((): boolean => props.isCorrectPin === false);
    const codeSent = computed((): boolean => hasSentPin.value && !wrongPin.value);

    const handlePin = (value: string) => {
      pin.value = value;
    };

    const sendPin = () => {
      hasSentPin.value = true;
      emit('sendPin');
    };

    const handleAnswer = () => {
      emit('answer', { type: AuthenticationStepType.VerifySms, value: pin.value });
    };

    const bindEnter = ({ key }: KeyboardEvent) => {
      if (key === 'Enter') {
        handleAnswer();
      }
    };

    onMounted(() => {
      document.addEventListener('keydown', bindEnter);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('keydown', bindEnter);
    });

    return {
      pin,
      hasSentPin,
      pinLength,
      description,
      infoText,
      lastFourDigits,
      disableValidate,
      wrongPin,
      codeSent,
      handlePin,
      sendPin,
      handleAnswer,
      bindEnter,
    };
  },
});
